import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fintech-solutions',
  templateUrl: './fintech-solutions.component.html',
  styleUrls: ['./fintech-solutions.component.css']
})
export class FintechSolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/fintech-solutions/fintech-solutions.component.ts